import restApiDispatcher from "@/store/utils/api-dispatcher";
import { CollegeEvent, CollegeEventList } from "@/models";

const getCollegeEvents = (context, params) =>
  restApiDispatcher(context, {
    resource: CollegeEvent,
    action: "index",
    loadingKey: "collegeEventsLoading",
    storeKey: "collegeEvents",
    commitType: "index",
    metaKey: "meta",
    params
  });

const getCollegeEventsLimited = (context, params) =>
  restApiDispatcher(context, {
    resource: CollegeEvent,
    action: "indexV2",
    loadingKey: "collegeEventsLoading",
    storeKey: "collegeEventsLimited",
    commitType: "index",
    metaKey: "meta",
    params
  });

  const getCollegeEventsV1 = (context, params) =>
  restApiDispatcher(context, {
    resource: CollegeEvent,
    action: "indexV2",
    loadingKey: "collegeEventsLoading",
    storeKey: "collegeTeamEvents",
    commitType: "index",
    metaKey: "meta",
    params
  });

const getCollegeEventsV2 = (context, params) =>
  restApiDispatcher(context, {
    resource: CollegeEvent,
    action: "indexV2",
    loadingKey: "collegeEventsLoading",
    storeKey: "collegeEvents",
    commitType: "index",
    metaKey: "meta",
    params
  });

const getCollegeEvent = (context, params) =>
  restApiDispatcher(context, {
    resource: CollegeEvent,
    action: "show",
    loadingKey: "collegeEventLoading",
    storeKey: "collegeEvent",
    commitType: "wrappedShow2",
    params
  });

const getCollegeEventsList = (context, params) =>
  restApiDispatcher(context, {
    resource: CollegeEventList,
    action: "index",
    loadingKey: "collegeEventsLoading",
    storeKey: "collegeListEvents",
    commitType: "index",
    metaKey: "meta",
    params
  });

const createCollegeEventsList = (context, params) =>
  restApiDispatcher(context, {
    resource: CollegeEventList,
    storeKey: "collegeEvents",
    loadingKey: "collegeEventsLoading",
    action: "create",
    commitType: "addToList",
    message: "Event successfully created.",
    params
  });

const updateCollegeEventsList = (context, params) =>
  restApiDispatcher(context, {
    resource: CollegeEventList,
    storeKey: "collegeListEvents",
    loadingKey: "collegeEventsLoading",
    action: "update",
    commitType: "edit",
    message: "Event successfully updated.",
    params
  });

const deleteCollegeEventsList = (context, params) =>
  restApiDispatcher(context, {
    resource: CollegeEventList,
    storeKey: "collegeEvent",
    loadingKey: "collegeEventsLoading",
    action: "delete",
    message: "Event successfully deleted.",
    params
  });

const updateImageForEvent = (context, params) =>
  restApiDispatcher(context, {
    resource: CollegeEventList,
    storeKey: "collegeListEvents",
    loadingKey: "collegeEventsLoading",
    action: "imageUpdate",
    commitType: "editImage",
    params
  });

const setFavourite = (context, collegeEventsId) =>
  context.commit("SET_FAVOURITE", collegeEventsId);

const unsetFavourite = (context, collegeEventsId) =>
  context.commit("UNSET_FAVOURITE", collegeEventsId);

export default {
  getCollegeEvent,
  getCollegeEvents,
  getCollegeEventsList,
  createCollegeEventsList,
  updateCollegeEventsList,
  deleteCollegeEventsList,
  updateImageForEvent,
  setFavourite,
  unsetFavourite,
  getCollegeEventsLimited,
  getCollegeEventsV2,
  getCollegeEventsV1
};
